<template>
        <div class="general">
                <AppHeader @navigate="handleNavigation" />
                <div class="projects-container">
                        <div class="projects-content">
                                <div class="projects-grid">
                                        <div class="create-block" @click="createNewProject">
                                                 <img :src="createProject" :alt="$t('legacy.Создать проект')">
                                                 <p>{{ $t('legacy.Создать проект') }}</p>
                                        </div>

                                        <template v-if="isLoading">
                                                <div v-for="n in 3" :key="'skeleton-' + n" class="project-card skeleton-card">
                                                        <div class="skeleton-preview"></div>
                                                        <div class="skeleton-info">
                                                                <div class="skeleton-title"></div>
                                                                <div class="skeleton-meta">
                                                                        <div class="skeleton-date"></div>
                                                                        <div class="skeleton-zone"></div>
                                                                </div>
                                                        </div>
                                                </div>
                                        </template>

                                        <template v-else>
                                                <div v-for="project in savedProjects" :key="project.id" class="project-card">
                                                <div class="project-preview" @click.stop="openProject(project)">
                                                         <img v-if="project.coverImage" :src="getFullImageUrl(project.coverImage)" :alt="$t('legacy.Превью проекта')" class="preview-image">
                                                         <img v-else :src="delperLogo" :alt="$t('legacy.Макетта')" class="preview-logo">
                                                </div>

                                                <div class="project-info">
                                                        <h3 class="project-title">{{ project.name }}</h3>
                                                        <div class="project-meta">
                                                                <span class="project-date">{{ formatDate(project.createdAt) }}</span>
                                                                <span class="project-zone">{{ getZoneTitle(project.zoneId) }}</span>
                                                        </div>
                                                </div>

                                                <div class="project-actions">
                                                        <img src="@/assets/images/content/settingsMyProject.svg" class="settings-icon"
                                                                @click.stop="toggleMenu(project.id)">

                                                        <transition name="fade">
                                                                <div v-if="activeMenuId === project.id" class="dropdown-menu">
                                                                        <div class="menu-item" @click="openProject(project)">
                                                                                <img :src="open" alt="open">
                                                                                 <span>{{ $t('legacy.Открыть') }}</span>
                                                                        </div>
                                                                        <div class="menu-item" @click="renameProject(project)">
                                                                                <img :src="rename" alt="rename">
                                                                                 <span>{{ $t('legacy.Переименовать') }}</span>
                                                                        </div>
                                                                        <div class="menu-item" @click="openCoverModal(project)">
                                                                                <img :src="newPhoto" alt="cover">
                                                                                 <span>{{ $t('legacy.Обложка') }}</span>
                                                                        </div>
                                                                        <div class="menu-item" @click="deleteProject(project)">
                                                                                <img :src="deleteProjectImage" alt="delete">
                                                                                 <span>{{ $t('common.delete') }}</span>
                                                                        </div>
                                                                </div>
                                                        </transition>
                                                </div>
                                                </div>
                                        </template>
                                </div>
                        </div>
                </div>
                <AppCreateFotozoneModal v-if="showCreateModal" :show="true" :existingTitles="savedProjects.map(p => p.name)"
                        :hasZones="savedProjects.length > 0" @close="showCreateModal = false" @create="handleCreateZone" />
                
                <AppCoverModal 
                        v-if="showCoverModal" 
                        :projectId="selectedProjectForCover?.id"
                        @close="closeCoverModal"
                        @save="handleCoverSave"
                />

                <!-- Rename Modal -->
                <transition name="fade">
                        <div v-if="showRenameModal" class="modal-overlay" @click="closeRenameModal">
                                <div class="rename-modal" @click.stop>
                                         <h3>{{ $t('legacy.Переименовать проект') }}</h3>
                                        <input 
                                                type="text" 
                                                v-model="newProjectName" 
                                                class="rename-input"
                                                 :placeholder="$t('legacy.Название проекта')"
                                                @keyup.enter="confirmRename"
                                                ref="renameInput"
                                        />
                                        <div class="modal-buttons">
                                                 <button class="btn-cancel" @click="closeRenameModal">{{ $t('common.cancel') }}</button>
                                                 <button class="btn-confirm" @click="confirmRename">{{ $t('common.save') }}</button>
                                        </div>
                                </div>
                        </div>
                </transition>

                <!-- Mobile Bottom Sheet -->
                <transition name="bottom-sheet">
                        <div v-if="activeMenuId && isMobile" class="bottom-sheet-overlay" @click="closeMenu">
                                <div class="bottom-sheet" @click.stop>
                                        <div class="bottom-sheet-handle"></div>
                                        <div class="bottom-sheet-content">
                                                <div class="menu-item" @click="openProject(activeProject)">
                                                        <img :src="open" alt="open">
                                                         <span>{{ $t('legacy.Открыть') }}</span>
                                                </div>
                                                <div class="menu-item" @click="renameProject(activeProject)">
                                                        <img :src="rename" alt="rename">
                                                         <span>{{ $t('legacy.Переименовать') }}</span>
                                                </div>
                                                <div class="menu-item" @click="openCoverModal(activeProject)">
                                                        <img :src="newPhoto" alt="cover">
                                                         <span>{{ $t('legacy.Обложка') }}</span>
                                                </div>
                                                <div class="menu-item delete-item" @click="deleteProject(activeProject)">
                                                        <img :src="deleteProjectImage" alt="delete">
                                                         <span>{{ $t('common.delete') }}</span>
                                                </div>
                                        </div>
                                </div>
                        </div>
                </transition>
        </div>
</template>

<script>
import { deleteProjectById, fetchProjectById, fetchProjects, saveProject } from '@/api/projects'
import {
        createProject as createProjectIcon,
        deleteProjectImage,
        newPhoto,
        open,
        rename
} from '@/assets/images/content/index'
import delperLogo from '@/assets/images/delper-logo.svg'
import AppCreateFotozoneModal from '@/components/AppCreateFotozoneModal.vue'
import AppCoverModal from '@/components/AppCoverModal.vue'
import AppHeader from '@/components/AppHeader.vue'

export default {
        name: 'ProjectsList',
        components: {
                AppHeader,
                AppCreateFotozoneModal,
                AppCoverModal
        },
        data() {
                return {
                        activeMenuId: null,
                        savedProjects: [],
                        isLoading: true,
                        isMobile: window.innerWidth <= 480,
                        fotozones: [
                                         { id: 0, title: 'legacy.выездной регистрации' },
                                         { id: 1, title: 'legacy.фотозоны' },
                                         { id: 2, title: 'legacy.столов гостей' },
                                         { id: 3, title: 'legacy.плана рассадки' },
                                         { id: 5, title: 'legacy.другой зоны' }
                        ],
                        createProject: createProjectIcon,
                        open,
                        rename,
                        newPhoto,
                        deleteProjectImage,
                        delperLogo,
                        showCreateModal: false,
                        showCoverModal: false,
                        selectedProjectForCover: null,
                        showRenameModal: false,
                        projectToRename: null,
                        newProjectName: '',
                }
        },
        computed: {
                activeProject() {
                        return this.savedProjects.find(p => p.id === this.activeMenuId)
                }
        },
        async created() {
                this.migrateLocalStorageZones()
                await this.loadProjects()
                document.addEventListener('click', this.handleClickOutside)
                window.addEventListener('resize', this.handleResize)
        },
        beforeUnmount() {
                document.removeEventListener('click', this.handleClickOutside)
                window.removeEventListener('resize', this.handleResize)
        },
        methods: {
                migrateLocalStorageZones() {
                        try {
                                const existingZones = JSON.parse(localStorage.getItem('fotozones') || '[]')
                                const validZones = existingZones.filter(zone => {
                                        return typeof zone.id === 'number' && zone.id < 1000000
                                })
                                
                                if (validZones.length !== existingZones.length) {
                                        localStorage.setItem('fotozones', JSON.stringify(validZones))
                                        console.log('Миграция localStorage: удалены зоны с некорректными ID')
                                }
                        } catch (error) {
                                console.error('Ошибка миграции localStorage:', error)
                                localStorage.setItem('fotozones', JSON.stringify([]))
                        }
                },
                async loadProjects() {
                        try {
                                this.isLoading = true
                                const response = await fetchProjects()
                                this.savedProjects = response.projects.map(project => ({
                                        id: project.id,
                                        name: project.name,
                                        zoneId: project.zone_id,
                                        coverImage: project.cover_image,
                                        preview: this.getProjectPreview(project),
                                        createdAt: new Date(project.created_at).toISOString(),
                                        content: project.data
                                }))
                        } catch (error) {
                                console.error('Ошибка загрузки проектов:', error)
                        } finally {
                                this.isLoading = false
                        }
                },
                async openProjectById(id) {
                        try {
                                const project = await fetchProjectById(id)
                                if (project) {
                                        this.$router.push(`/projects/${project.id}`)
                                }
                        } catch (error) {
                                 alert(this.$t('legacy.Не удалось загрузить проект.'))
                                console.error('Ошибка открытия проекта по id:', error)
                        }
                },
                createNewProject() {
                        this.showCreateModal = true
                },
                async handleCreateZone(zoneTitle) {
                        try {
                                this.showCreateModal = false

                                const newProject = {
                                        title: zoneTitle
                                }

                                const response = await saveProject(newProject)
                                if (response && response.project && response.project.id) {
                                        const createdProject = {
                                                id: response.project.id,
                                                name: zoneTitle,
                                                preview: '',
                                                createdAt: new Date(response.project.created_at).toISOString()
                                        }
                                        this.savedProjects.unshift(createdProject)
                                        
                                        this.$router.push(`/projects/${response.project.id}`)
                                }
                        } catch (error) {
                                console.error('Ошибка создания проекта:', error)
                                 alert(this.$t('legacy.Не удалось создать проект.'))
                        }
                },
                async openProject(project) {
                        this.activeMenuId = null
                        this.$router.push(`/projects/${project.id}`)
                },
                getProjectPreview(project) {
                        try {
                                const decodedData = atob(project.data)
                                const content = JSON.parse(decodedData)
                                const image = content.find(item => item.type === 'image' && !item.isBackground)
                                return image?.content || ''
                        } catch {
                                return project.preview || ''
                        }
                },
                getFullImageUrl(imagePath) {
                        if (!imagePath) return null
                        if (imagePath.startsWith('http')) return imagePath
                        return imagePath
                },
                getZoneTitle(zoneId) {
                        const zone = this.fotozones.find(z => z.id === zoneId)
                         return zone ? zone.title : ''
                },
                formatDate(dateString) {
                         if (!dateString) return this.$t('legacy.Нет даты')
                        const date = new Date(dateString)
                         if (isNaN(date)) return this.$t('legacy.Некорректная дата')
                        const options = { year: 'numeric', month: 'long', day: 'numeric' }
                         return this.$formatDate(date, options)
                },
                handleNavigation(destination) {
                        const routes = {
                                'constructor': '/constructor',
                                'projects': '/projects'
                        }
                        if (routes[destination]) {
                                this.$router.push(routes[destination])
                        }
                },
                toggleMenu(projectId) {
                        this.activeMenuId = this.activeMenuId === projectId ? null : projectId
                },
                closeMenu() {
                        this.activeMenuId = null
                },
                handleResize() {
                        this.isMobile = window.innerWidth <= 480
                },
                handleClickOutside(event) {
                        if (this.$el && !this.$el.contains(event.target)) {
                                this.activeMenuId = null
                        }
                },
                renameProject(project) {
                        this.projectToRename = project
                        this.newProjectName = project.name
                        this.showRenameModal = true
                        this.activeMenuId = null
                        this.$nextTick(() => {
                                if (this.$refs.renameInput) {
                                        this.$refs.renameInput.focus()
                                        this.$refs.renameInput.select()
                                }
                        })
                },
                closeRenameModal() {
                        this.showRenameModal = false
                        this.projectToRename = null
                        this.newProjectName = ''
                },
                async confirmRename() {
                        if (!this.projectToRename) return
                        const newName = this.newProjectName.trim()
                        if (newName && newName !== this.projectToRename.name) {
                                try {
                                        const updatedProject = {
                                                id: this.projectToRename.id,
                                                name: newName,
                                                data: this.projectToRename.content,
                                                zone_id: this.projectToRename.zoneId,
                                                zone_title: this.getZoneTitle(this.projectToRename.zoneId)
                                        }
                                        await saveProject(updatedProject)
                                        this.projectToRename.name = newName
                                } catch (error) {
                                        console.error('Ошибка обновления проекта:', error)
                                }
                        }
                        this.closeRenameModal()
                },
                async deleteProject(project) {
                         if (confirm(this.$t('legacy.dynamic.projectDelete', { projectName: project.name }))) {
                                try {
                                        await deleteProjectById(project.id)

                                        // Закрываем шторку на мобильной версии
                                        this.activeMenuId = null

                                        // Автоматическое удаление: обновляем список проектов после удаления
                                        await this.loadProjects()

                                        console.log(`Проект "${project.name}" успешно удален`)
                                } catch (error) {
                                        console.error('Ошибка удаления проекта:', error)
                                         alert(this.$t('legacy.Не удалось удалить проект.'))
                                }
                        }
                },
                openCoverModal(project) {
                        this.selectedProjectForCover = project
                        this.showCoverModal = true
                        this.activeMenuId = null
                },
                closeCoverModal() {
                        this.showCoverModal = false
                        this.selectedProjectForCover = null
                },
                handleCoverSave(coverImageUrl) {
                        if (!this.selectedProjectForCover) return
                        
                        const project = this.savedProjects.find(p => p.id === this.selectedProjectForCover.id)
                        if (project && coverImageUrl) {
                                project.coverImage = coverImageUrl
                        }
                        this.closeCoverModal()
                },
        }
}
</script>

<style scoped>
/* Стили остаются без изменений */
.general {
        background: #FAF9F7;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        overflow: auto;
}

.projects-container {
        flex: 1;
        display: flex;
        padding: 10px 20px 20px;
}

.projects-content {
        flex: 1;
        padding: 20px;
        overflow-y: auto;
        background-color: white;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        scrollbar-width: none;
        -ms-overflow-style: none;
}

.create-block {
        background: white;
        align-items: center;
        justify-content: center;
        gap: 10px;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 250px;
        position: relative;
}

.create-block:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        background-color: #f8faff;
}

.create-block img {
        width: 40px;
        height: 40px;
        object-fit: contain;
        transition: transform 0.3s ease;
}

.create-block:hover img {
        transform: scale(1.05);
}

.create-block p {
        font-size: 18px;
        color: #26374e;
        margin: 0;
        font-weight: 400;
        font-family: 'Montserrat', sans-serif;
        line-height: 1.4;
}

.projects-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 25px;
        margin-top: 20px;
}

.project-card {
        background: white;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
}

.project-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.project-preview {
        height: 180px;
        background-color: #f0f2f5;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
}

.preview-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
}

.preview-logo {
        width: 80%;
        height: auto;
        object-fit: contain;
        opacity: 0.5;
}

.no-preview {
        color: #7a8a99;
        font-size: 14px;
}

.project-info {
        padding: 15px;
        border-top: 1px solid #e0e4e8;
}

.project-title {
        font-weight: 600;
        margin-bottom: 8px;
        color: #26374e;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
}

.project-date {
        color: #7a8a99;
        font-size: 13px;
        margin-bottom: 5px;
}

.project-zone {
        color: #496782;
        font-size: 12px;
        font-style: italic;
}

.settings-icon {
        position: absolute;
        bottom: 1rem;
        right: 1rem;
        width: 40px;
        height: 40px;
        cursor: pointer;
        padding: 6px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 50px;
        transition: 0.2s;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dropdown-menu {
        position: absolute;
        top: 3rem;
        right: 1rem;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 10;
        min-width: 160px;
}

.menu-item {
        display: flex;
        align-items: center;
        padding: 0.75rem 1rem;
        font-size: 0.9rem;
        color: #606266;
        cursor: pointer;
        transition: 0.2s;
}

.menu-item:hover {
        background: #f5f7fa;
}

.menu-item img {
        width: 18px;
        height: 18px;
        margin-right: 0.75rem;
}

.fade-enter-active,
.fade-leave-active {
        transition: opacity 0.2s, transform 0.2s;
}

.fade-enter,
.fade-leave-to {
        opacity: 0;
        transform: translateY(-10px);
}

/* Skeleton loaders */
.skeleton-card {
        pointer-events: none;
}

.skeleton-preview {
        height: 180px;
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
}

.skeleton-info {
        padding: 15px;
        border-top: 1px solid #e0e4e8;
}

.skeleton-title {
        height: 18px;
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
        border-radius: 4px;
        margin-bottom: 12px;
        width: 70%;
}

.skeleton-meta {
        display: flex;
        flex-direction: column;
        gap: 8px;
}

.skeleton-date {
        height: 14px;
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
        border-radius: 4px;
        width: 50%;
}

.skeleton-zone {
        height: 12px;
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: shimmer 1.5s infinite;
        border-radius: 4px;
        width: 40%;
}

@keyframes shimmer {
        0% {
                background-position: -200% 0;
        }
        100% {
                background-position: 200% 0;
        }
}

@media (max-width: 768px) {
        .general {
                height: auto;
                min-height: 100vh;
                overflow: auto;
        }

        .projects-container {
                padding: 0 10px 10px;
                flex: none;
        }

        .projects-content {
                padding: 10px;
                margin-left: 0;
                overflow: visible;
                padding-bottom: 30px;
        }

        .projects-grid {
                grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
                gap: 15px;
        }

        .project-preview {
                height: 150px;
        }

        .skeleton-preview {
                height: 150px;
        }

        .settings-icon {
                width: 36px;
                height: 36px;
        }
}

@media (max-width: 480px) {
        .projects-grid {
                grid-template-columns: repeat(2, 1fr);
                gap: 10px;
        }

        .create-block {
                min-height: 125px;
                gap: 5px;
                justify-content: center;
                align-items: center;
        }

        .create-block img {
                width: 30px;
                height: 30px;
        }

        .create-block p {
                font-size: 14px;
                text-align: center;
        }

        .settings-icon {
                top: 0.5rem;
                right: 0.5rem;
                bottom: auto;
                width: 32px;
                height: 32px;
                padding: 4px;
        }

        .dropdown-menu {
                display: none;
        }
}

/* Bottom Sheet Styles */
.bottom-sheet-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        display: flex;
        align-items: flex-end;
        justify-content: center;
}

.bottom-sheet {
        background: white;
        width: 100%;
        border-radius: 20px 20px 0 0;
        padding: 10px 20px 30px;
        max-height: 80vh;
        overflow-y: auto;
}

.bottom-sheet-handle {
        width: 40px;
        height: 4px;
        background: #ddd;
        border-radius: 2px;
        margin: 0 auto 15px;
}

.bottom-sheet-content .menu-item {
        display: flex;
        align-items: center;
        padding: 16px 10px;
        font-size: 16px;
        color: #26374e;
        border-bottom: 1px solid #f0f2f5;
        cursor: pointer;
}

.bottom-sheet-content .menu-item:last-child {
        border-bottom: none;
}

.bottom-sheet-content .menu-item img {
        width: 24px;
        height: 24px;
        margin-right: 15px;
}

.bottom-sheet-content .menu-item.delete-item {
        color: #e74c3c;
}

/* Bottom Sheet Animation */
.bottom-sheet-enter-active,
.bottom-sheet-leave-active {
        transition: all 0.3s ease;
}

.bottom-sheet-enter-active .bottom-sheet,
.bottom-sheet-leave-active .bottom-sheet {
        transition: transform 0.3s ease;
}

.bottom-sheet-enter-from,
.bottom-sheet-leave-to {
        opacity: 0;
}

.bottom-sheet-enter-from .bottom-sheet,
.bottom-sheet-leave-to .bottom-sheet {
        transform: translateY(100%);
}

/* Rename Modal Styles */
.modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
}

.rename-modal {
        background: white;
        border-radius: 16px;
        padding: 24px;
        width: 100%;
        max-width: 400px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.rename-modal h3 {
        margin: 0 0 20px;
        font-size: 18px;
        font-weight: 600;
        color: #26374e;
        text-align: center;
}

.rename-input {
        width: 100%;
        padding: 14px 16px;
        border: 2px solid #e0e4e8;
        border-radius: 10px;
        font-size: 16px;
        color: #26374e;
        transition: border-color 0.2s;
        box-sizing: border-box;
}

.rename-input:focus {
        outline: none;
        border-color: #496782;
}

.modal-buttons {
        display: flex;
        gap: 12px;
        margin-top: 20px;
}

.btn-cancel,
.btn-confirm {
        flex: 1;
        padding: 14px 20px;
        border: none;
        border-radius: 10px;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
}

.btn-cancel {
        background: #f0f2f5;
        color: #606266;
}

.btn-cancel:hover {
        background: #e0e4e8;
}

.btn-confirm {
        background: #496782;
        color: white;
}

.btn-confirm:hover {
        background: #3a5569;
}

/* Fade Animation */
.fade-enter-active,
.fade-leave-active {
        transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
        opacity: 0;
}
</style>